import { render, staticRenderFns } from "./CaseControl.vue?vue&type=template&id=13b04ec0&scoped=true"
import script from "./CaseControl.vue?vue&type=script&lang=js"
export * from "./CaseControl.vue?vue&type=script&lang=js"
import style0 from "./CaseControl.vue?vue&type=style&index=0&id=13b04ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b04ec0",
  null
  
)

export default component.exports